import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from 'app/rootReducer';
import { commonApi } from 'shared/api/commonApi';

export const setupStore = (preloadedState?: Partial<RootState>) =>
	configureStore({
		reducer: rootReducer,
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({ serializableCheck: false }).concat([commonApi.middleware]),
	});

export const store = setupStore();

// Infer the `AppStore`, `RootState`, `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof setupStore>;
